import React from "react";

function Footer() {
  return (
    <div className="footer">
      <div className="footer__container">Built by Lars Walderhaug</div>
    </div>
  );
}

export default Footer;
